/**
 * FRN search type values
 */
export enum FrnSearchTypeEnum {
    Frn = 'FRN',
    Name = 'NAME',
}
